var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "j5Ctst",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.446,
    height: 43.25,
    viewBox: "0 0 41.446 43.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-1",
    d: "M812.792,48h1.861c.083.013.165.033.248.038a18.814,18.814,0,0,1,4.184.7A20.523,20.523,0,0,1,830.607,57.1a21.626,21.626,0,0,1,3.718,10.223c.046.444.081.89.121,1.335V70.6c-.012.086-.032.172-.036.259a20.458,20.458,0,0,1-.489,3.618,21.434,21.434,0,0,1-8.855,13.244,19.515,19.515,0,0,1-9.133,3.407c-.426.047-.853.085-1.28.127h-1.861c-.083-.013-.165-.033-.248-.038a19.187,19.187,0,0,1-5.993-1.3,20.805,20.805,0,0,1-10.7-9.351,21.6,21.6,0,0,1-2.729-8.635c-.045-.444-.081-.889-.121-1.333V68.654c.026-.291.055-.581.078-.873a21.471,21.471,0,0,1,1.388-6.152,21.2,21.2,0,0,1,9.322-10.981,19.465,19.465,0,0,1,7.7-2.52C811.925,48.08,812.359,48.043,812.792,48Zm11.646,9.648c-.105-.1-.2-.193-.29-.279a14.51,14.51,0,0,0-12.171-3.812,14.676,14.676,0,0,0-8.156,3.84,16.449,16.449,0,0,0-4.88,16.058,15.558,15.558,0,0,0,9.905,11.451,14.9,14.9,0,0,0,9.318.421,13.4,13.4,0,0,0,9.03-7.357,17.519,17.519,0,0,0,1.56-10.369c-.033-.236-.107-.291-.327-.29q-7.052.011-14.1.005h-.283V72.87h8.795c-.017.115-.024.2-.044.285a8.36,8.36,0,0,1-3.822,5.42,8.688,8.688,0,0,1-3.653,1.214,9.258,9.258,0,0,1-5.025-.732,10.436,10.436,0,0,1-5.432-12.563,9.759,9.759,0,0,1,8.482-7.079,8.544,8.544,0,0,1,5.111,1.129c.627.371,1.2.845,1.821,1.291Z",
    transform: "translate(-793 -48)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.592d570c.svg";
export { ForwardRef as ReactComponent };